import Vue from 'vue'
import App from './App.vue'
import { mixin as clickaway } from 'vue-clickaway'
import router from './router'
import store from './store'
import i18n from './i18n'
import './plugins'
import Loading from '@/components/utils/Loading.vue'
import axios from 'axios'
import moment from 'moment'

Vue.component('loading', Loading)
Vue.mixin(clickaway)

Vue.config.productionTip = false
Vue.use(require('vue-moment'))

Vue.filter('dateTime', (val, format, parsing) => {
	return moment(val, parsing).format(format)
})

Vue.filter('verifyEmail', async (email) => {
	let result = await axios({
		method: 'get',
		url: 'https://api.usebouncer.com/v1/email/verify',
		headers: { 'X-API-KEY': 'LB5Mvl0Xefy6uFhBhFGTVtiz6JA66e15Q2DWS5Jk' },
		params: { email: email }
	})

	return result.data.status === 'deliverable'
})

const requireComponent = require.context(
	'./components',
	// look for subfolder
	true,
	/(App|Layout)[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName)
	const componentName = fileName
		.split('/')
		.pop()
		.replace(/\.\w+$/, '')

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	)
})

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
